var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isGeet)?_c('div',{staticClass:"_geet_box",attrs:{"id":"huakuai"}},[_c('i',{ref:"btn"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }